import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const SharedContactsIcon = (props: SvgIconProps) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon width="25" height="25" viewBox="0 0 24 19" fill="none" {...props}>
    <path
      // eslint-disable-next-line max-len
      d="M1.25586 2C1.25586 1.30964 1.8155 0.75 2.50586 0.75H20.5059C21.1962 0.75 21.7559 1.30964 21.7559 2V13C21.7559 13.6904 21.1962 14.25 20.5059 14.25H2.50586C1.8155 14.25 1.25586 13.6904 1.25586 13V2Z"
      stroke="#0B7CB7"
      strokeWidth="1.5"
      fill="transparent"
    />
    <mask id="mask0_71422_11548" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="3" y="2" width="8" height="10">
      <rect x="3.43555" y="2.26221" width="7.03493" height="9.67303" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_71422_11548)">
      <path
        // eslint-disable-next-line max-len
        d="M9.97048 13.0357C9.97048 14.4074 9.59883 15.6266 9.02424 16.4883C8.44732 17.3535 7.7052 17.8107 6.95301 17.8107C6.20083 17.8107 5.4587 17.3535 4.88178 16.4883C4.30719 15.6266 3.93555 14.4074 3.93555 13.0357C3.93555 11.614 4.15273 10.3986 4.6383 9.55523C5.10171 8.75035 5.81883 8.26074 6.95301 8.26074C8.0872 8.26074 8.80431 8.75035 9.26772 9.55523C9.75329 10.3986 9.97048 11.614 9.97048 13.0357Z"
        fill="white"
        stroke="#0B7CB7"
      />
    </g>
    <circle cx="6.92969" cy="5.75526" r="2.38087" fill="white" stroke="#0B7CB7" />
    <rect x="11.5059" y="4" width="7" height="1" fill="#0B7CB7" />
    <rect x="11.5059" y="6" width="7" height="1" fill="#0B7CB7" />
    <rect x="11.5059" y="8" width="7" height="1" fill="#0B7CB7" />
    <rect x="13.5059" y="10" width="5" height="1" fill="#0B7CB7" />
  </SvgIcon>
)

export default SharedContactsIcon
